export default {"src":"/_next/static/media/clock.c3da9c8c.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};